import { render } from "./NewOverlayDialog.htm?vue&type=template&id=2394f571&scoped=true&ts=true"
import script from "./NewOverlayDialog.vue?vue&type=script&lang=ts"
export * from "./NewOverlayDialog.vue?vue&type=script&lang=ts"

import "./NewOverlayDialog.scss?vue&type=style&index=0&id=2394f571&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2394f571"]])

export default __exports__